/** Keep doctor id keys consistent (MUI Select uses strings; API may return numbers). */
export const normalizeDoctorId = (doctorId) =>
  doctorId == null || doctorId === "" ? null : String(doctorId);
